import React from "react";
import { Col, Form, Input, Modal, Row, Select, DatePicker, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import dayjs from "dayjs";
import useDropdownItem from "../../common/useDropdownItem";
import { URL_POND, URL_TANK } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { useParams } from "react-router-dom";
import ErrorMessages from "../../common/ErrorMessages";
import { POND_STATUS } from "../../constants/string";
import { formatComma, toFixed } from "../../frameworks/Util";
import _ from "lodash";

export default function StorageTankFillModal(props) {
  const { open, onClose, onUpdate, target } = props;
  const isCreate = target == 'add';
  const [errorMessages, setErrorMessages] = React.useState()
  const params = useParams();
  const [form] = Form.useForm();
  const [debouncedLotPond, setDebouncedLotPond] = React.useState('')
  const debounceLotPond = React.useCallback(_.debounce((_searchVal) => { setDebouncedLotPond(_searchVal) }, 800), []);

  const pondTransactionOptions = useDropdownItem({ 
    manual: true,
    url: URL_POND.POND_TRANSACTION, 
    label_renderer :(value) => `${value.lot_no} น้ำหนัก: ${formatComma(value.current_weight)}`, 
    value:'id', 
    pagination: true, 
    params: { 
      lot_no : debouncedLotPond,  
      page_size: 999,
      state: isCreate ? POND_STATUS.PRODUCING : ''} 
    })

  const { token : { colorWarning }} = theme.useToken();

  const handleOK = async() => {
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data['tank_transaction'] = params.id
      if(isCreate){
        await POST(URL_TANK.TANK_POND_TRANSACTION, data)
      } else {
        delete data['raw_latex_weight']
        await PATCH(`${URL_TANK.TANK_POND_TRANSACTION}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);;
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      pondTransactionOptions.fetchOptions();
      if(!isCreate){
        form.setFieldsValue({
          pond_transaction : target.pond_transaction, 
          raw_latex_weight : target.raw_latex_weight,
          start : target.start ? dayjs(target.start) : null, 
          end : target.end ? dayjs(target.end) : null,
        })
      } else {
        form.resetFields();
      }
    }
  },[open])

  React.useEffect(() => {
    if(open){
      pondTransactionOptions.fetchOptions();
    }
  },[debouncedLotPond])

  return(
    <Modal
      open={open}
      onCancel={onClose}
      width={600}
      okText={ isCreate ? "ตกลง" : "แก้ไข"}
      onOk={handleOK}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning }}}
      cancelText={"ปิด"}
      title={"เทน้ำยางลงแทงก์"}
    >
      <ErrorMessages message={errorMessages}/>
      <Form 
        layout='vertical'
        form={form}>
          <Row>
            <Col span={14}>
              <Form.Item
                name={'pond_transaction'}
                label={'ล็อตน้ำยางสด'}
                style={{ marginRight : 10 }}
                rules={[{ required: true, message : 'กรุณากรอกข้อมูล'}]}
              >
                <Select 
                  showSearch
                  disabled={isCreate ? false : true} 
                  placeholder="ล็อตน้ำยางสด" 
                  options={pondTransactionOptions.options}
                  onSelect={(value, option) => {
                    form.setFieldValue('raw_latex_weight', toFixed(option.current_weight, 0))
                  }}
                  filterOption={false}
                  onSearch={debounceLotPond}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item 
                name={'raw_latex_weight'}
                label={'น้ำหนักน้ำยางสด (Kg)'}
                rules={[{ required: true, message : 'กรุณากรอกข้อมูล'}]}
              >
                <Input disabled={isCreate ? false : true} placeholder="น้ำหนักน้ำยางสด (Kg)"/>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label={'เริ่มเดินเครื่อง'}
                name={'start'}
                style={{ marginRight : 10 }}
              >
                <DatePicker 
                  showTime={{
                    format: "HH:mm",
                  }}
                  format="YYYY-MM-DD HH:mm"
                  style={{ width : '100%' }} 
                  placeholder="เริ่มเดินเครื่อง"/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label={'สิ้นสุดการเดินเครื่อง'}
                name={'end'}
                style={{ marginRight : 10 }}
              >
                <DatePicker 
                  showTime={{
                    format: "HH:mm",
                  }}
                  style={{ width : '100%' }} 
                  format="YYYY-MM-DD HH:mm"
                  placeholder="สิ้นสุดการเดินเครื่อง"/>
              </Form.Item>
            </Col>
          </Row>
      </Form>
    </Modal>
  )
}
